import clsx from 'clsx';
import { TbChevronRight } from 'react-icons/tb';
import type { MobileNavigationItem } from './types';
import MenuLink from './MenuLink';

interface MenuRowProps {
  item: MobileNavigationItem;
  onOpen: (item: MobileNavigationItem) => void;
}

export default function MenuRow({ item, onOpen }: MenuRowProps) {
  return (
    <li
      className={clsx('bio-mobile-menu__item', {
        'bio-mobile-menu__item--spaced': item.spaceBelow,
      })}
    >
      {item.children.length > 0 ? (
        <button
          type="button"
          className="bio-mobile-menu__row"
          data-menu-branch={item.id}
          onClick={() => onOpen(item)}
        >
          <span>{item.label}</span>
          <TbChevronRight size={16} className="bio-mobile-menu__chevron" />
        </button>
      ) : item.heading || !item.url ? (
        <span className="bio-mobile-menu__row bio-mobile-menu__heading">
          {item.label}
        </span>
      ) : (
        <MenuLink item={item} label={item.label} />
      )}
    </li>
  );
}
